<template>
  <div id="app" class="app-content mb-4">
    <app-header></app-header>
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 text-center">
          <div class="amej-title">
            <h1>Payment via Amej Pay</h1>
          </div>
        </div>
      </div>
      <div class="row" v-show="!show">
        <div class="col-lg-8 col-md-8 offset-md-2">
          <!-- <div v-if="message">
          <p v-if="message>0">{{message}}</p>
          </div>-->
          <b-form @submit.prevent id="myForm">
            <b-form-group label-for="pay-email">
              <b-form-input
                disabled
                v-model="wallet"
                id="pay-email"
                type="email"
                placeholder="Amej ID"
              ></b-form-input>

              <span class="text-danger pr-1">*</span>
Amej ID
              <!-- <span class="text-danger float-right" v-if="errors.email">
              {{ errors.email}}
              </span>-->
            </b-form-group>

            <b-form-group label-for="amount">
              <b-form-input
                disabled
                id="amount"
                v-model="amount"
                type="text"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                placeholder="Amount"
              ></b-form-input>

              <span class="text-danger pr-1">*</span>
Amount
              <!-- <span class="text-danger float-right" v-if="errors.amount">
              {{ errors.amount}}
              </span>-->
            </b-form-group>

            <!-- <b-form-group label-for="remarks">
             <b-form-textarea placeholder="Remarks" id="remarks" rows="5"></b-form-textarea>

             <span class="text-danger pr-1">*</span>Remarks

             <span class="text-danger float-right" v-if="errors.remarks">
              {{ errors.remarks}}
            </span>
            </b-form-group>-->

            <b-button
              type="submit"
              variant="amej-button"
              :class="{available:available}"
              v-on:click="formshow()"
            >Continue</b-button>
          </b-form>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-8 col-md-8 offset-md-2">
          <transition name="fade">
            <div v-show="show">
              <b-form @submit.prevent>
                <b-form-group label-for="otp">
                  <label>
                    <span class="text-danger pr-1">*</span>A 4-digt OTP code has been sent on your mobile phone.
                    <br />Please enter the OTP Code:
                  </label>
                  <b-form-input
                    id="otp"
                    type="text"
                    maxlength="4"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    placeholder="OTP code"
                  ></b-form-input>
                  <!-- <span class="text-danger float-right" v-if="errors.bank_name">
                  {{ errors.bank_name}}
                  </span>-->
                </b-form-group>

                <div class="col-md-12 text-center">
                  <b-button type="submit" variant="amej-button">Complete Transaction</b-button>
                </div>
              </b-form>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "../reuseable_components/Header.vue";

export default {
  name: "EPay",
  components: {
    "app-header": AppHeader,
  },
  data() {
    return {
      available: false,
      show: false,
      amount: 0,
      wallet: "",
    };
  },
  methods: {
    formshow() {
      (this.show = !this.show), (this.available = !this.available);
    },
  },
  created() {
    this.amount = this.$route.params.amount;
    this.wallet = this.$route.params.wallet;
    // this.$http.get('/epay')
  },
};
</script>

<style lang="scss" scoped>
  @import '../../css/style.scss';

.fade-enter-active,
.fade-leave-active {
  transition: all 1s !important;
}

.fade-enter,
.fade-leave-to {
  opacity: 0 !important;
  transform: translateY(30px) !important;
}
</style>
